import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";
import { useAppTranslation } from "../../hooks/useAppTranslation";

interface ConfirmDailogProps {
  dailogTitle?: string;
  dailogDescription?: string;
  isDailogOpen: any;
  handleCancelAction: () => void;
  handleConfirmAction: () => void;
  whiteSpace?: string;
}

const ConfirmDailog: React.FC<ConfirmDailogProps> = ({
  isDailogOpen,
  handleCancelAction,
  handleConfirmAction,
  dailogTitle,
  dailogDescription,
  whiteSpace,
}) => {
  const { t } = useAppTranslation();
  const handleDialogClose = (
    _event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    // Prevent closing on backdrop click or ESC key
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    // For other reasons, allow normal closing
    handleCancelAction();
  };

  return (
    <Dialog
      open={isDailogOpen}
      onClose={handleDialogClose}
      className="modal-dialog-1"
    >
      <DialogTitle className="dialog-title">
        <span>{dailogTitle}</span>
      </DialogTitle>
      <DialogContent className="dialog-content">
        <DialogContentText
          sx={{ fontSize: "16px", whiteSpace: whiteSpace || "" }}
        >
          {dailogDescription}
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-footer">
        <Button
          onClick={handleCancelAction}
          className="btn-orange btn-dark"
          sx={{ marginRight: "8px" }}
        >
          {t("common.buttons.cancel")}
        </Button>
        <Button onClick={handleConfirmAction} className="btn-orange">
          {t("common.buttons.continue")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDailog;
